import React, { useRef, useEffect, useCallback, useState } from 'react';
import classes from './Login.module.css';
import fl_logo from '../../assets/fl_logo.png';
import { AccountCircleOutlined, LockOpenOutlined } from '@material-ui/icons';
import CustomTextField from '../../ui/CustomTextField';
import CustomPasswordField from '../../ui/CustomPasswordField';
import CustomButton from '../../ui/CustomButton';
import { useLocation, useHistory } from 'react-router-dom';
import { useStore } from '../../store/store';
import useV3Axios from '../../hooks/useV3Axios';
import { LOGOUT, HD_LOGIN } from '../../store/actionTypes';
import CustomSpinner from '../../ui/CustomSpinner';
import { REGISTER_PATH, FORGOT_PASSWORD_PATH } from '../../utils/paths';

const Login = () => {
    const dispatch = useStore(false)[1];
    const { isLoading, error: axiosError, data, sendRequest } = useV3Axios();
    const [error, setError] = useState(null);

    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (data) {
            dispatch(HD_LOGIN, { data });
            const currentSeconds = new Date().getTime() / 1000;
            const timeout = ((parseInt(data.expiresAt) - parseInt(currentSeconds)) * 1000);
            setTimeout(() => { dispatch(LOGOUT, { pathName: location.pathname }); }, timeout);
        }
    }, [data, dispatch, location]);

    useEffect(() => {
        if (axiosError) setError(axiosError);
    }, [axiosError]);

    const emailOrUsernameRef = useRef(null);
    const passwordRef = useRef(null);

    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        setError(null);
        sendRequest('/auth/login', {
            emailOrUsername: emailOrUsernameRef.current.value.trim(),
            password: passwordRef.current.value,
        });
    }, [sendRequest]);

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = width <= 768;

    return (
        <div className={classes.Login}>
            <div className={classes.Card}>
                <img className={classes.Logo} src={fl_logo} alt="logo" />
                <p className={classes.Title}>Fetal Lite Dashboard</p>
                {!isMobile && (
                    <form className={classes.Form} onSubmit={handleSubmit}>
                        <CustomTextField margin="10px auto" reference={emailOrUsernameRef} required id='emailOrUsername' label='Email or Username' type='text'>
                            <AccountCircleOutlined />
                        </CustomTextField>
                        <CustomPasswordField reference={passwordRef} id='password' label='Password'>
                            <LockOpenOutlined />
                        </CustomPasswordField>
                        {error && <p className={classes.Error}>{error}</p>}
                        <div className={classes.Container}>
                            <span className={classes.Link} onClick={() => history.push(FORGOT_PASSWORD_PATH)}>Forgot password?</span>
                            {isLoading ? <CustomSpinner /> : <CustomButton type='submit' size='large'>LOGIN</CustomButton>}
                        </div>
                        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
                            <span style={{ fontSize: '14px', color: '#555' }}>New here? </span>
                            <span className={classes.Link} onClick={() => history.push(REGISTER_PATH)}>Create an account</span>
                        </div>
                    </form>
                )}
                {isMobile && <h2>Please use a desktop or a laptop to view this webpage. If already using, please use this in full screen mode.</h2>}
            </div>
        </div>
    );
};

export default Login;
